import {Validator, AbstractControl, NG_VALIDATORS}from'@angular/forms'
import {Directive, Input}from'@angular/core'
import * as moment from 'moment';
@Directive({
    selector:'[minTime]',
    providers:[{
        provide:NG_VALIDATORS,
        useExisting:MinTimeValidator,
        multi:true
    }]
})
export class MinTimeValidator implements Validator{
    @Input() minTime;
    validate(control:AbstractControl):{[key:string]:boolean}|null{
        const value=this.tConvert(control.value)
        if(control.parent && control.parent.get(this.minTime) && control.value){
        const givenDate=control.parent.get(this.minTime).value
        let scheduledDate=moment(givenDate).format("YYYY-MM-DD")
        let currDate=moment(new Date()).format("YYYY-MM-DD")
        if(currDate==scheduledDate){
            if(control.value){
                var currentDate = new Date();
                let scheduledHour=Number(value.split(":")[0])
                let scheduledMinutes=Number(value.split(':')[1])
                var newDateObj = moment( currentDate).add(15, 'm').toDate();
                let currentHours=newDateObj.getHours()
                let currentMinutes=newDateObj.getMinutes()
                if(scheduledHour<currentHours){
                    return{timeIncorrect:true}
                }
                else if(scheduledHour==currentHours){
                    if(scheduledMinutes<currentMinutes){
                        return{timeIncorrect:true}
                    }
               }
              }
            }
        }
        return null
    }
    tConvert(time:string){
    if(time && time.match("^([1-9]|[1][0-2]):([0-5][0-9])[' '](AM|PM)$")){
        let timeString=time.split(' ')[0]
        let AmPm=time.split(' ')[1].toLowerCase()
        let hours=Number(timeString.split(":")[0])
        let mins=Number(timeString.split(":")[1])
        if(AmPm=='pm'&& hours<12){
           hours=hours+12
        }
        if(AmPm=='am'&&hours==12){
            hours=hours-12
        }
        let sHours=hours.toString()
        let sMins=mins.toString()
        if(hours<10) sHours='0'+sHours
        if(mins<10)    sMins='0'+sMins
        return sHours+":"+sMins

       }
    }

}
